/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

h5 = h5 || {};
h5.poweractions = {
   angularModule: angular.module('com.vmware.vsphere.client.poweractions', [])
};